import React from 'react'
import {Icon} from '@chakra-ui/react'

const AccessoriesCountIcon = (props) => {
    return (
        <Icon viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M10.8573 10.2857V5.71429C10.8573 4.38021 10.8573 3.71317 10.5874 3.20824C10.3743 2.80954 10.0477 2.483 9.64905 2.26989C9.14411 2 8.47707 2 7.143 2C5.80892 2 5.14188 2 4.63695 2.26989C4.23826 2.483 3.91171 2.80954 3.69861 3.20824C3.42871 3.71317 3.42871 4.38021 3.42871 5.71429V10.2857C3.42871 11.6198 3.42871 12.2868 3.69861 12.7918C3.91171 13.1905 4.23826 13.517 4.63695 13.7301C5.14188 14 5.80892 14 7.143 14C8.47707 14 9.14411 14 9.64905 13.7301C10.0477 13.517 10.3743 13.1905 10.5874 12.7918C10.8573 12.2868 10.8573 11.6198 10.8573 10.2857Z"
                stroke="currentColor"
                strokeWidth="1.5"
            />
            <path
                d="M3.42871 9.71429L10.4287 9.71429"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                opacity="0.1"
            />
            <path
                d="M4 6H10.7912H13.2912M13.2912 6V9.5M13.2912 6V4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </Icon>
    )
}

export default AccessoriesCountIcon
